import { axios } from '../configs';
import type {
  TSummaryClickedUsersResponse,
  TSummaryDetail,
  TLegacySummaryRow,
  TSummaryResponse,
  TSummarySourceType,
} from 'types/summary';

export type TGetSummaryParams = {
  currentPage: number;
  pageSize: number;
  sourceType?: TSummarySourceType;
};

export type TGetLegacySummaryParams = Pick<
  TGetSummaryParams,
  'currentPage' | 'pageSize'
>;

export const getSummaryByDateRange = async (
  from: string,
  to: string,
  params: TGetSummaryParams,
): Promise<TSummaryResponse> => {
  const res = await axios.get<TSummaryResponse>('messages/summary', {
    params: { from, to, ...params },
  });
  return res.data;
};

export const getLegacySummaryByDateRange = async (
  from: string,
  to: string,
  params: TGetLegacySummaryParams,
): Promise<TSummaryResponse<TLegacySummaryRow>> => {
  const res = await axios.get<TSummaryResponse<TLegacySummaryRow>>(
    'messages/summary',
    {
      params: { from, to, ...params, mode: 'LEGACY_OPEN' },
    },
  );
  return res.data;
};

export const getSummaryDetail = async (
  dispatchId: string,
): Promise<TSummaryDetail> => {
  const res = await axios.get<TSummaryDetail>(`messages/summary/${dispatchId}`);
  return res.data;
};

export type TGetSummaryClickedUsersParams = {
  currentPage: number;
  pageSize: number;
};

export const getSummaryClickedUsers = async (
  dispatchId: string,
  params: TGetSummaryClickedUsersParams,
): Promise<TSummaryClickedUsersResponse> => {
  const res = await axios.get<TSummaryClickedUsersResponse>(
    `messages/summary/${dispatchId}/clicked-users`,
    { params },
  );
  return res.data;
};
